import React from 'react';

interface EventMapProps {
    lat: number;
    lng: number;
    title?: string;
    address?: {
        fullAddress: string;
        country: string;
        state: string;
        city: string;
        zipcode: string;
    };
}

const EventMap: React.FC<EventMapProps> = ({ lat, lng, title, address }) => {
    const staticMapUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=15&size=600x256&maptype=roadmap&markers=color:red%7C${lat},${lng}&key=AIzaSyBKbmD1FAPDpYvIFHjUJpeZ9XbohnH_QFI`;

    return (
        <img
            onClick={() => {
                if (lat && lng) {
                    // Detect if user is on iOS
                    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

                    if (isIOS) {
                        // Open Apple Maps on iOS
                        window.open(`https://maps.apple.com/?q=${lat},${lng}`, '_blank');
                    } else {
                        // Open Google Maps on other devices
                        window.open(`https://www.google.com/maps?q=${lat},${lng}`, '_blank');
                    }
                }
            }}
            src={staticMapUrl}
            alt={`Map showing location of ${title || address?.fullAddress || 'event'}`}
            className="w-full h-[256px] object-cover rounded border"
        />
    );
};

export default EventMap; 